<legend class="small-label">Arianna configuration</legend>

<div class="col-md-3" *ngFor="let p of parametersList">
  <mat-form-field>
    <input matInput [(ngModel)]="params[p.key]" (ngModelChange)="isValidForm()" [placeholder]="p.label" />
  </mat-form-field>
</div>
